export default {
    int_random(m, n) {
        return Math.floor(Math.random() * (m - n) + n);
    },
    table_sort_orderby(orderStr) {
        let order = {
            null: '',
            ascending: 'asc',
            descending: 'desc',
        };
        return order[orderStr] || ''
    },
}


